





















import Vue from 'vue'

export default Vue.extend({
  name: 'CockpitDetailDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    dialogData: Object as () => any
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    }
  },

  mounted (): void {
    setTimeout(() => {
      const closeBtn: any = this.$refs['closeBtn']
      if (closeBtn) {
        closeBtn.$el.focus()
      }
    })
  }
})
